import { Select , Row , Col , Button , Table , message , Checkbox , Form } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingAction } from "../actions/loading-actions";
import { getAllowedBookingOperators, getSchedulesWithSharingFlags, updateScheduleSharingFlags } from "../actions/service-sharing.actions";
import '../styles/service-sharing.style.scss';
import { isValid, isValidArray } from "../utils/utilities";

const { Option } = Select;

const getOriginDestinationFilters=(data)=>{
    let origins = [] , destinations = [] , filteredOrigins = [] , filteredDestinations = [];
    if(isValidArray(data)){
        data.forEach(element => {
            if(origins.indexOf(element.origin) == -1){
                origins.push(element.origin);
                filteredOrigins.push({
                    text:element.origin,
                    value:element.origin
                });
            }

            if(destinations.indexOf(element.destination) == -1){
                destinations.push(element.destination);
                filteredDestinations.push({
                    text:element.destination,
                    value:element.destination
                });
            }
        });
    }

    return {
        filteredOrigins,
        filteredDestinations
    }
}

const formatTripTime=(time)=>{
    if(!isValid(time)){
        return '';
    }
    let [hours,minutes] = time.split(':');
    hours = parseInt(hours);
    let meridiem = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    if(hours == 0){
        hours = 12;
    }
    return `${hours.toString().padStart(2,'0')}:${minutes} ${meridiem}`;
}

export const ServiceSharingPage = () => {

    const dispatch = useDispatch();

    const [form] = Form.useForm();

    const [allowedOperators,setAllowedOperators] = useState([]);
    const [selectedOperator,setSelectedOperator] = useState(null);
    const [activeSchedules,setActiveSchedules] = useState([]);
    const [originFilters,setOriginFilters] = useState([]);
    const [destinationFilters,setDestinationFilters] = useState([]);

    const setLoading=(bool)=>{
        dispatch(loadingAction(bool))
    }

    useEffect(()=>{
        getAllowedBookingOperators((operators)=>{
            setAllowedOperators(operators);
        },
        (errMsg)=>{
            message.error(errMsg);
        });
    },[]);

    const printOperatorOptions = () => {
        let operatorOptions = [];
        if(isValidArray(allowedOperators)){
            allowedOperators.map((operator) => {
                operatorOptions.push(<Option key={operator.operator_code} value={operator.operator_code}>{operator.name}</Option>);
            });
        }
        return operatorOptions;
    }

    const onSuccess=(data)=>{
        let {
            filteredOrigins,
            filteredDestinations
        } = getOriginDestinationFilters(data);
        setOriginFilters(filteredOrigins);
        setDestinationFilters(filteredDestinations);
        setActiveSchedules(data);
        setLoading(false);
    }

    const onFailure=(errMsg)=>{
        message.error(errMsg);
        setLoading(false);
    }

    const onSearch=()=>{
        form.validateFields()
        .then(values => {
            setSelectedOperator(values.operatorCode);
            setLoading(true);
            getSchedulesWithSharingFlags(onSuccess,onFailure);
        })
        .catch(()=>{
            message.warning("Please select operator");
        });
    }

    const localUpdateSharingFlags=(scheduleId,allowSharing,hideBookingFromChild)=>{
        activeSchedules.forEach((element,index)=>{
            if(element.id == scheduleId){
                activeSchedules[index].allow_sharing = allowSharing;
                activeSchedules[index].hide_booking_from_child = hideBookingFromChild;
            }
        });
        setActiveSchedules([...activeSchedules]);
        setLoading(false);
    }

    const onToggleSharingFlags=(record,allowSharing,hideBookingFromChild)=>{
        setLoading(true);
        let operatorInfo = allowedOperators.find((operator) => operator.operator_code == selectedOperator);
        let data = {
            scheduleId:record.id,
            allowSharing:allowSharing?1:0,
            hideBookingFromChild:hideBookingFromChild?1:0,
            operatorCode:global.operatorCode,
            allowedOperatorCode:selectedOperator,
            allowedOperatorName:isValid(operatorInfo)?operatorInfo.name:selectedOperator
        }
        updateScheduleSharingFlags(data,()=>{
            localUpdateSharingFlags(record.id,data.allowSharing,data.hideBookingFromChild);
        },
        (errMsg)=>{
            message.error(errMsg);
            setLoading(false);
        });
    }

    return (
        <div className="service-sharing-root">
            <div className={`service-sharing-inner-div`}>
                <Form
                    initialValues={{}}
                    form={form}
                >
                    <Row gutter={[16,16]} align="middle" className="service-sharing-search-row">
                        <Col>
                            <Form.Item
                                className="form-operator"
                                name="operatorCode"
                                rules={[{ required: true , message:"Please select operator"}]}
                                label="Select Operator">
                                    <Select
                                        placeholder="Select operator"
                                        className="service-sharing-operator-selector"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                            {printOperatorOptions()}
                                    </Select>
                            </Form.Item>
                        </Col>
                        <Col>
                            <Button type="primary" onClick={onSearch}>Go</Button>
                        </Col>
                    </Row>
                </Form>
                {isValid(selectedOperator)&&
                    <Row>
                        <Col>
                            <Table
                                dataSource={activeSchedules}
                                rowKey="id"
                                columns={[
                                    {
                                        title:"Service ID",
                                        dataIndex:'id',
                                        key:'id',
                                        sorter:(a,b)=>a.id-b.id
                                    },
                                    {
                                        title:"Service Name",
                                        dataIndex:'description',
                                        key:'description'
                                    },
                                    {
                                        title:"Trip Time",
                                        dataIndex:'start_time',
                                        key:'start_time',
                                        render:(text)=>formatTripTime(text)
                                    },
                                    {
                                        title:"From City",
                                        dataIndex:'origin',
                                        key:'origin',
                                        filters:originFilters,
                                        onFilter: (value, record) => record.origin.indexOf(value) === 0
                                    },
                                    {
                                        title:"To City",
                                        dataIndex:'destination',
                                        key:'destination',
                                        filters:destinationFilters,
                                        onFilter: (value, record) => record.destination.indexOf(value) === 0
                                    },
                                    {
                                        title:"Allow Sharing",
                                        dataIndex:'allow_sharing',
                                        key:'allow_sharing',
                                        render:(text,row)=>{
                                            return(
                                                <Checkbox checked={text==1} onChange={(e)=>{
                                                    onToggleSharingFlags(row,e.target.checked,row.hide_booking_from_child==1);
                                                }} />
                                            )
                                        }
                                    },
                                    {
                                        title:"Hide Parent Bookings From Child (Trip Sheet & Tooltip)",
                                        dataIndex:'hide_booking_from_child',
                                        key:'hide_booking_from_child',
                                        render:(text,row)=>{
                                            return(
                                                <Checkbox checked={text==1} onChange={(e)=>{
                                                    onToggleSharingFlags(row,row.allow_sharing==1,e.target.checked);
                                                }} />
                                            )
                                        }
                                    }
                                ]}
                                pagination={false}
                            />
                        </Col>
                    </Row>
                }
            </div>
        </div>
    )
}
